import { render, staticRenderFns } from "./FileType.vue?vue&type=template&id=1c5b9f60&"
import script from "./FileType.vue?vue&type=script&lang=js&"
export * from "./FileType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports